<template>
<div id="Waple">
  <router-view>
    
  </router-view>
  <div v-if="this.loading" class="page-Loading">
    <div>
      <span class="loading-1"></span>
      <span class="loading-2"></span>
      <span class="loading-3"></span>
    </div>
  </div>
  <!--  -->
</div>
  
</template>

<script>
import axios from 'axios'
import { defualtMeta } from '@/utils/meta';

export default {
  name: "App",
  data: () => ({
    loading : false,
  }),
  metaInfo: {
    meta: defualtMeta,
  },
  // watch: {
  //   '$store.state.ui.child': function() {
  //     var that = this;
  //     var childName = this.$store.state.ui.child.name;

  //     if(childName == 'pop-close-refresh') {
  //       that.$router.go(that.$router.currentRoute);
  //     } 
  //   }
  // },
  components: {},
  methods: {
    showBlockUi() {
      this.loading = true;
    },
    hideBlockUi() {
      // alert("hideBlockUi");
      this.loading = false;
    },
    chkWorkNotice() {
      var that = this;
      axios.get('/worknotice.json').then(function(resonse) {
              var workYn = resonse.data.workYn;
              if(workYn == 'Y') {
                  that.$router.push({ name: "work-notice" }).catch(function() {});
              } 
          }).catch(function() {});
    }
  },
  created: function() {
    console.log("App.vue-created", this.$root);
    this.$root.$on('request-before', this.showBlockUi);
    this.$root.$on('request-error', this.hideBlockUi);
    this.$root.$on('response-after', this.hideBlockUi);
    this.$root.$on('response-error', this.hideBlockUi);
    this.chkWorkNotice();
  },
  updated: function() {
    this.chkWorkNotice();
  },
  beforeDestroy() {
      this.$root.$off('request-before', this.showBlockUi);
      this.$root.$off('request-error', this.hideBlockUi);
      this.$root.$off('response-after', this.hideBlockUi);
      this.$root.$off('response-error', this.hideBlockUi);
  }
};

</script>
